import { z } from 'zod';

export const UserRole = {
  ADMIN: 'admin',
  MEMBER: 'member',
  VIEWER: 'viewer',
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

// Judicial jurisdictions — user-selectable in add-in generation wizard (Step 5).
// WHY a separate schema: admin courts (CE, CAA, TA) exist in the full Jurisdiction
// type but are not yet exposed to users ("Droit Public" is comingSoon in the picker).
export const JudicialJurisdictionSchema = z.enum(['CC', 'CA', 'TJ', 'TCOM']);
export type JudicialJurisdiction = z.infer<typeof JudicialJurisdictionSchema>;

// Full jurisdiction set (judicial + administrative courts).
export const JurisdictionSchema = z.enum(['CC', 'CA', 'TJ', 'TCOM', 'CE', 'CAA', 'TA']);
export type Jurisdiction = z.infer<typeof JurisdictionSchema>;

// Validated array of judicial jurisdictions — used for the user-selected override.
export const JurisdictionsArraySchema = JudicialJurisdictionSchema.array().min(1);

// Single source of truth for the max number of user-selected jurisdictions accepted
// from the add-in. Shared between (1) route normalization (parseJurisdictionsCsv
// in jobs.routes.ts) and (2) Zod schemas in workers/research-only.ts and
// workers/generate-document.ts. WHY a constant rather than inline `.max(10)`:
// drift between route cap and Zod cap would silently truncate or fail-open.
export const MAX_JURISDICTIONS = 10;
